import React from "react";
import { Button } from "../../components/Button/Button";
import { FormikProvider, useFormik } from "formik";
import { Asserts, object, string } from "yup";
import { useNavigate } from "react-router-dom";
import { useMutation } from "react-query";
import { AuthService } from "../../services/auth.service";
import { toast } from "react-hot-toast";
import { TextInput } from "../../components/FormInputs/TextInput";

export const ResetPassword = () => {
  const navigate = useNavigate();

  const validationSchema = object({
    username: string().required().label("Username"),
    oldPassword: string().required().label("Old password"),
    password: string().required().label("new password"),
  });

  const form = useFormik<Asserts<typeof validationSchema>>({
    initialValues: {
      username: "",
      oldPassword: "",
      password: "",
    },
    validationSchema,
    onSubmit: (values) => {
      resetPassword.mutate(values);
    },
  });

  const resetPassword = useMutation(
    async (values: { username: string; password: string }) => {
      return await AuthService.changePassword(values);
    },
    {
      onSuccess: (response) => {
        if (response.data.responseCode === "00") {
          toast.success("Password reset successful");
          requestAnimationFrame(() => {
            navigate("/login");
          });
        }
      },
      onError: (err: any) => {
        toast.error(err.response.data.responseMessage);
        console.log("ERROR", err.response);
      },
    }
  );
  return (
    <div>
      <div className="card bg-white rounded-md p-9">
        <div className="flex justify-around">
          <img src={"/images/pc-logo.svg"} className="" alt="Paycenter_logo" />
        </div>
        <div className="mt-6">
          <h5 className="text-center font-bold">Reset Password</h5>
        </div>
        <div>
          <FormikProvider value={form}>
            <form onSubmit={form.handleSubmit}>
              <div className="mt-4 w-80">
                <TextInput
                  type="text"
                  label="Enter ID"
                  {...form.getFieldProps("username")}
                  placeholder="Enter your ID"
                  context
                />
              </div>

              <div className="mt-4 ">
                <TextInput
                  type="password"
                  label="Old Password"
                  {...form.getFieldProps("oldPassword")}
                  placeholder="Enter Password"
                  context
                />
              </div>
              <div className="mt-4 ">
                <TextInput
                  type="password"
                  label="New Password"
                  {...form.getFieldProps("password")}
                  placeholder="Enter Password"
                  context
                />
              </div>

              <div className="mt-4">
                <Button
                  label="Reset Password"
                  className="justify-center"
                  fullWidth
                  disabled={false}
                />
              </div>
              {/* <div className="mt-6">
                <a href="#" className="hover:underline">
                  <p className="text-sm text-blue-500 text-center">
                    Didn’t get reset link? Resend
                  </p>
                </a>
              </div> */}
              <div className="mt-6">
                <a href="/login" className="hover:underline">
                  <p className="text-sm text-blue-500 text-center">
                    Back to login
                  </p>
                </a>
              </div>
            </form>
          </FormikProvider>
        </div>
      </div>
    </div>
  );
};
